import React from "react";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { languages } from "../../constants/languages";
import { countDecimals } from "../../util/CountDecimals";
import { mdiAccountCheck } from "@mdi/js";
import Icon from "@mdi/react";
import CheckIcon from "@material-ui/icons/CheckCircle";
import IconButton from "@material-ui/core/IconButton";

const RankingTable = (props) => {
  const showPresent =
    ((props.tournament.defaultFields || {})["present"] || {}).show ||
    props.tournament.requireCheckIn ||
    false;

  return (
    <div style={{ marginTop: 5, overflowX: "auto" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ paddingRight: 30 }}>
              {languages.results.rank}
            </TableCell>
            {showPresent && (
              <TableCell>
                {/* {languages.teams.present} */}
                <Icon path={mdiAccountCheck} size={1} />
              </TableCell>
            )}
            <TableCell style={{ padding: 0 }}>
              {languages.results.team}
            </TableCell>
            <TableCell style={{ padding: 0, minWidth: 150 }}>
              {languages.results.standing}
            </TableCell>
            <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
              {languages.results.pouleResults.points}
            </TableCell>
            {props.useSets && (
              <>
                <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                  <b>{languages.results.pouleResults.setsFor}</b>
                </TableCell>
                <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                  <b>{languages.results.pouleResults.setsAgainst}</b>
                </TableCell>
                <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                  <b>{languages.results.pouleResults.setsDifference}</b>
                </TableCell>
              </>
            )}
            <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
              {props.tournament.standingsTableWithPoints
                ? languages.results.pouleResults.pointsFor
                : languages.results.pouleResults.goalsFor}
            </TableCell>
            <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
              {props.tournament.standingsTableWithPoints
                ? languages.results.pouleResults.pointsAgainst
                : languages.results.pouleResults.goalsAgainst}
            </TableCell>
            <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
              {props.tournament.standingsTableWithPoints
                ? languages.results.pouleResults.pointsDifference
                : languages.results.pouleResults.goals}
            </TableCell>
            {Object.keys(props.tournament.customPoints || {}).map((key, i) => {
              let customPoints = props.tournament.customPoints[key];
              return <TableCell key={key}>{customPoints.abbr}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.ranking.map((ranking, i) => {
            let toFixed = 0;
            let numDecimals = countDecimals(ranking.pouleScore);
            if (numDecimals > 1) {
              toFixed = 1;
            } else {
              toFixed = numDecimals;
            }
            let toFixedGoals = 0;
            let numDecimalsGoals = countDecimals(ranking.goals);
            if (numDecimalsGoals > 1) {
              toFixedGoals = 1;
            } else {
              toFixedGoals = numDecimalsGoals;
            }
            let toFixedSets = 0;
            let numDecimalsSets = countDecimals(ranking.sets);
            if (numDecimalsSets > 1) {
              toFixedSets = 1;
            } else {
              toFixedSets = numDecimalsSets;
            }
            let toFixedSetsFor = 0;
            let numDecimalsSetsFor = countDecimals(ranking.setsFor);
            if (numDecimalsSetsFor > 1) {
              toFixedSetsFor = 1;
            } else {
              toFixedSetsFor = numDecimalsSetsFor;
            }
            let toFixedSetsAgainst = 0;
            let numDecimalsSetsAgainst = countDecimals(ranking.setsAgainst);
            if (numDecimalsSetsAgainst > 1) {
              toFixedSetsAgainst = 1;
            } else {
              toFixedSetsAgainst = numDecimalsSetsAgainst;
            }
            let toFixedGoalsFor = 0;
            let numDecimalsGoalsFor = countDecimals(ranking.goalsFor);
            if (numDecimalsGoalsFor > 1) {
              toFixedGoalsFor = 1;
            } else {
              toFixedGoalsFor = numDecimalsGoalsFor;
            }
            let toFixedGoalsAgainst = 0;
            let numDecimalsGoalsAgainst = countDecimals(ranking.goalsAgainst);
            if (numDecimalsGoalsAgainst > 1) {
              toFixedGoalsAgainst = 1;
            } else {
              toFixedGoalsAgainst = numDecimalsGoalsAgainst;
            }
            return (
              <TableRow key={props.division + i} style={{ height: 53 }}>
                <TableCell style={{ paddingRight: 30 }}>
                  {!ranking.hideRank && i + 1 + "."}
                </TableCell>
                {showPresent && (
                  <TableCell
                    style={{ minWidth: 30, paddingRight: 0, paddingLeft: 12 }}
                  >
                    {ranking.team.present && (
                      <IconButton
                        // edge="end"
                        disabled
                        style={{ width: 30, height: 30 }}
                      >
                        <CheckIcon
                          style={{
                            height: 17,
                            position: "absolute",
                            top: 7,
                            color: "green",
                          }}
                        />
                      </IconButton>
                    )}
                  </TableCell>
                )}
                <TableCell style={{ padding: 0, minWidth: 120 }}>
                  {ranking.team.gamertag || ranking.team.name}
                </TableCell>
                <TableCell style={{ padding: 0, minWidth: 150 }}>
                  {ranking.fromPouleName}
                </TableCell>
                <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                  {!ranking.isBracket
                    ? ranking.pouleScore.toFixed(toFixed)
                    : ""}
                </TableCell>
                {props.useSets && (
                  <>
                    <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                      {!ranking.isBracket
                        ? ranking.setsFor.toFixed(toFixedSetsFor)
                        : ""}
                    </TableCell>
                    <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                      {!ranking.isBracket
                        ? ranking.setsAgainst.toFixed(toFixedSetsAgainst)
                        : ""}
                    </TableCell>
                    <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                      {!ranking.isBracket
                        ? ranking.sets.toFixed(toFixedSets)
                        : ""}
                    </TableCell>
                  </>
                )}
                <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                  {!ranking.isBracket
                    ? ranking.goalsFor.toFixed(toFixedGoalsFor)
                    : ""}
                </TableCell>
                <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                  {!ranking.isBracket
                    ? ranking.goalsAgainst.toFixed(toFixedGoalsAgainst)
                    : ""}
                </TableCell>
                <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                  {!ranking.isBracket
                    ? ranking.goals.toFixed(toFixedGoals)
                    : ""}
                </TableCell>
                {Object.keys(props.tournament.customPoints || {}).map(
                  (key, i) => {
                    return (
                      <TableCell key={key}>
                        {(props.customPoints[(ranking.team || {}).id] || {})[
                          key
                        ] || 0}
                      </TableCell>
                    );
                  }
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default RankingTable;
